// Header.jsx
import React, { useState, useEffect } from "react";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    setTimeout(() => setIsVisible(true), 100);

    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`glass-header ${scrolled ? "scrolled" : ""} ${isVisible ? "visible" : ""}`}>
      <div className="header-container">
        {/* Logo */}
        <div className="logo-container animate-slide-down" style={{ animationDelay: '0.1s' }}>
          <div className="logo-icon">
            <div className="logo-circle"></div>
            <div className="logo-inner"></div>
          </div>
          <h1 className="logo-text">FlyFi</h1>
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <ul className="nav-links">
            <li className="animate-slide-down" style={{ animationDelay: '0.2s' }}>
              <a href="#home" className="nav-link">
                <span className="nav-dot"></span>
                Home
              </a>
            </li>
            <li className="animate-slide-down" style={{ animationDelay: '0.3s' }}>
              <a href="#download" className="nav-link">
                Download App
              </a>
            </li>
            <li className="animate-slide-down" style={{ animationDelay: '0.4s' }}>
              <a href="#about" className="nav-link">
                About
              </a>
            </li>
          
            <li className="animate-slide-down" style={{ animationDelay: '0.6s' }}>
              <a href="#contact" className="nav-link">
                Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Right Actions */}
        <div className="header-actions">
          <button onClick={() => window.location.href = "https://uda.flyfi.com.ng/auth/login"} className="btn-signin animate-slide-down" style={{ animationDelay: '0.7s' }}>
            Sign In
          </button>
          <button onClick={() => window.location.href = "https://uda.flyfi.com.ng/auth/register"} className="btn-cta animate-slide-down" style={{ animationDelay: '0.8s' }}>
            <span>Get Started</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          {/* Mobile Menu Toggle */}
          <button 
            className="mobile-menu-toggle animate-slide-down"
            style={{ animationDelay: '0.7s' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className={`hamburger ${mobileMenuOpen ? "open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
        <nav className="mobile-nav">

            {/* Close Button */}
            <button className="mobile-close-btn" onClick={() => setMobileMenuOpen(false)}>
            ✕
            </button>

            <a href="#home" className="mobile-nav-link">
            <span className="mobile-nav-icon">.</span>
            Home
            </a>
            <a href="#download" className="mobile-nav-link">
            <span className="mobile-nav-icon">.</span>
            Download App
            </a>
            <a href="#about" className="mobile-nav-link">
            <span className="mobile-nav-icon">.</span>
            About
            </a>
            <a href="#contact" className="mobile-nav-link">
            <span className="mobile-nav-icon">.</span>
            Contact
            </a>

            <div className="mobile-menu-actions">
            <button onClick={() => window.location.href = "https://uda.flyfi.com.ng/auth/login"} className="mobile-btn-signin">Sign In</button>
            <button onClick={() => window.location.href = "https://uda.flyfi.com.ng/auth/register"} className="mobile-btn-cta">Get Started</button>
            </div>

        </nav>
        </div>

    </header>
  );
};

export default Header;